import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { realtorBookingConstants } from '..';

export const useRealtorBookingSend = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { flatId?: number; note?: string; delay: number; leadId?: number | null }) => {
      const res = await $api.post('/v1/realtor-booking/send', data);

      return res.data;
    },
    {
      onSuccess: (data, { leadId }) => {
        qc.invalidateQueries([realtorBookingConstants.queryKeys.REALTOR_BOOKING_LEAD, { leadId }]);
        showMessage(data?.message, data?.accept);
      }
    }
  );
};
